import React, { useEffect, useRef, useState } from "react";
import { Avatar, Box, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper } from '@mui/material';
import { getAllSites } from "../../../selectors/AdminSelectors";
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router-dom";
import { StyledTextField } from "../../common/StyledTextField";
import { ArrowBackIos, ArrowForwardIos, Settings, StorefrontOutlined } from "@mui/icons-material";
import { TooltipIconButton } from "../../common/StyledButtons";
import Colors from "../../../constants/Colors";
import StyledSubHeader from "../../common/StyledSubHeader";
import { isAdmin } from "../../../actions/profile/UserActions";
import { getAllUsersForAdmin } from "../../../actions/internal/AdminActions";
import { getUserId } from "../../../selectors/UserSelectors";
import { NOTIFICATION_TYPE, showNotificationBar } from "../../../actions/error-pages/NotificationBarActions";
import { StyledLoadingSection } from "../../common/StyledProgressCircle";
import { getAllUsers } from "../../../clients/bettercallkyle/BckApi";
import StyledPage from "../../common/StyledPage";

const PAGE_LIMIT = 10;

const AdminUsersPage = ({ history }) => {

    const defaultUserSet = useRef();

    const [filteredUsers, setFilteredUsers] = useState([]);
    const [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(true)

    const loadData = async () => {
        if (!isAdmin()) {
            history.replace('/dashboard');
            return;
        }
        try {
            const userId = getUserId();
            const users = await getAllUsersForAdmin(userId);
            defaultUserSet.current = users;
            setFilteredUsers(users);
        } catch(err) {
            const e = await err;
            console.error(e);
            showNotificationBar(NOTIFICATION_TYPE.ERROR, 'Uh oh! There was a problem retrieving site information.')
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    const loadingContent = (
        <StyledLoadingSection />
    )

    const handleSearchAccounts = (e) => {
        const users = defaultUserSet.current.filter(user => {
            if (user.user_personal.first_name.toLowerCase().includes(e.target.value.toLowerCase())) return true;
            if (user.user_personal.last_name.toLowerCase().includes(e.target.value.toLowerCase())) return true;
            if (user.user_login_id.toLowerCase().includes(e.target.value.toLowerCase())) return true;
            return false;
        })
        setFilteredUsers(users || []);
        setOffset(0)
    }

    if (isLoading) return (loadingContent)

    // Implement Search and Pagination next
    return (
        <StyledPage>
            <StyledSubHeader title="User Accounts" />
            <Grid container spacing={2} sx={{ marginTop: '24px' }}>
                <Grid item xs={12}>
                    <h5 style={{ padding: 0, margin: 0}}>Overview ({filteredUsers ? filteredUsers.length : 0} Total)</h5>
                </Grid>
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ padding: '16px'}}>
                        <StyledTextField
                            label="Search Accounts"
                            onChange={handleSearchAccounts}
                        />
                        <List style={{ flex: 1 }}>
                            {filteredUsers.slice(offset, offset + PAGE_LIMIT).map((user) => (
                                <ListItem
                                    dense
                                    button
                                    onClick={() => history.push(`/admin/users/manage?u=${user.user_login_id}`)}
                                    sx={{ backgroundColor: '#fff', marginBottom: '5px', paddingTop: '10px', paddingBottom: '10px' }}
                                    key={user.user_login_id}>
                                    <ListItemText
                                        primary={`${user.user_personal.first_name} ${user.user_personal.last_name}`}
                                        secondary={user.user_login_id}
                                    />
                                    <ListItemSecondaryAction>
                                        <TooltipIconButton
                                            text={'Manage Business Account'}
                                            icon= {<Settings sx={{ color: Colors.primaryColor, fontSize: '24px' }}
                                            onClick={() => history.push(`/admin/users/manage?u=${user.user_login_id}`)}
                                        /> } />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                            {filteredUsers.length === 0 && 
                            <ListItem>
                                <p>No business accounts found.</p>
                            </ListItem>
                            }
                        </List>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <TooltipIconButton
                                icon={<ArrowBackIos />}
                                text={'Previous page'}
                                disabled={offset === 0}
                                onClick={() => setOffset(offset - PAGE_LIMIT)}
                            />
                            <h6 style={{ fontSize: '16px', paddingTop: '10px' }}>{(offset / PAGE_LIMIT) + 1}</h6>
                            <TooltipIconButton
                                icon={<ArrowForwardIos />}
                                text={'Next page'}
                                disabled={offset + PAGE_LIMIT > filteredUsers.length}
                                onClick={() => setOffset(offset + PAGE_LIMIT)}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </StyledPage>
    )
}

export default withRouter(observer(AdminUsersPage));

